module.exports = __webpack_public_path__ + "img/icon-remove-red.5d5ddadf.svg";